import { FiBold, FiUnderline } from "react-icons/fi";
import { GoItalic } from "react-icons/go";

export const FONTS = [
  { label: "Arial", value: "Arial" },
  { label: "Courier New", value: "Courier New" },
  { label: "Georgia", value: "Georgia" },
  { label: "Times New Roman", value: "Times New Roman" },
  { label: "Verdana", value: "Verdana" },
  { label: "Calibri", value: "Calibri" },
  { label: "Roboto", value: "Roboto" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Oswald", value: "Oswald" },
  { label: "Pacifico", value: "Pacifico" },
];

export const COLOR_OPTIONS = [
  { label: "Black", value: "#000000" },
  { label: "Red", value: "#F50606" },
  { label: "Orange", value: "#FF6600" },
  { label: "Yellow", value: "#FFDD55" },
  { label: "Green", value: "#01AB31" },
  { label: "Purple", value: "#9301AB" },
  { label: "Pink", value: "#FF5995" },
  { label: "Blue", value: "#063AF5" },
  { label: "Navy", value: "#2F4A82" },
  { label: "Dark Grey", value: "#403E3D" },
  { label: "Grey", value: "#666666" },
  { label: "White", value: "#ffffff" },
  { label: "Silver", value: "#ECE7EA" },
  { label: "Gold", value: "#FFC633" },
];

export const TOOLBAR_OPTIONS = [
  { command: "bold", key: "fontWeight", icon: <FiBold /> },
  { command: "italic", key: "fontStyle", icon: <GoItalic /> },
  {
    command: "underline",
    key: "textDecoration",
    icon: <FiUnderline />,
  },
];
